var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { attrs: { id: "nav" } },
        [
          _c(
            "b-navbar",
            { attrs: { toggleable: "lg", type: "dark", variant: "dark" } },
            [
              _c("b-navbar-brand", { attrs: { href: "/#/" } }, [
                _vm._v("larsbutler.net")
              ]),
              _vm._v(" "),
              _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
              _vm._v(" "),
              _c(
                "b-collapse",
                { attrs: { id: "nav-collapse", "is-nav": "" } },
                [
                  _c(
                    "b-navbar-nav",
                    [
                      _c("b-nav-item", { attrs: { href: "/#/" } }, [
                        _vm._v("Home")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-nav-item-dropdown",
                        { attrs: { text: "D&D", right: "" } },
                        [
                          _c(
                            "b-dropdown-item",
                            { attrs: { href: "/#/dnd/character-sheet" } },
                            [_vm._v("Character Sheet (5e)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { attrs: { href: "/#/dnd/ogl" } },
                            [_vm._v("Open Game License")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-nav",
                    { staticClass: "ml-auto" },
                    [
                      !_vm.isUserLoggedIn()
                        ? _c(
                            "b-nav-item",
                            { attrs: { href: _vm.loginUrl() } },
                            [_vm._v("Login")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isUserLoggedIn()
                        ? _c(
                            "b-nav-item-dropdown",
                            {
                              attrs: {
                                text: _vm.getLoggedInUserEmail(),
                                right: ""
                              }
                            },
                            [
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: _vm.logoutUrl() } },
                                [_vm._v("Logout")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 